import State from "@/helpers/pattern/state";
import { Vendor } from "@/models/operativos/vendor";
import { modelIsModified } from "@/helpers/vue-mc";
import vendorAPI from "@/services/operativos/vendor";
import CombosAPI from "@/services/catalogos";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { clearSwal } from "@/constants/sweet-alerts";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { setSelectsInactiveDataMultipleJson, getJson, setJson } from "@/helpers/form-common";

/**
 * State Pattern for vendor form
 */
export default class VendorStates extends State {
  /**
   * Class constructor, important pass the required data within the states methods
   * @param {*} data Any type of data that you want available within the states methods
   */

  constructor(data) {
    super(data);
  }

  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) this.clear();
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        $data.vendor = new Vendor();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.vendor) || $data.view.action.submit.busy || !modelIsModified($data.vendor);
      }
      , async loadSelectsData({ $data }) {
        const { data: { results: { combo: repList } } } = await CombosAPI.get({ option: "rep" });
        $data.view.elem.select.rep.filteredList = repList ? repList.filter((value) => value.status) : [];
        $data.view.elem.select.rep.completeList = repList || [];
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function ({ $data }) {
          // Reset Models and validators
          this.resetModel();
          this.loadSelectsData();
          this.resetValidators();

          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.save;
        }
        , async submit({ $data }, { descripcion, canales, rep, email, emailFacturacion, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy = true;

            const response = await vendorAPI.save({
              clave: null
              , descripcion
              , canales: canales.join()
              , rep: setJson(rep)
              , email: email != null && email != "" ? email.join() : null
              , emailFacturacion: emailFacturacion != null && emailFacturacion != "" ? emailFacturacion.join() : null
              , status
            });

            $data.view.action.submit.busy = false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.vendorTable.refreshData();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
      , editing: {
        $constructor: function ({ $data }, { clave, descripcion, canales, rep, email, emailFacturacion, status }) {
          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.update;

          // Set options to combos if not are active
          $data.view.elem.select.rep.filteredList = setSelectsInactiveDataMultipleJson(rep, $data.view.elem.select.rep.completeList);

          $data.view.elem.select.email.filteredList = [];
          if (email != null && email != undefined && email != "") {
            $data.view.elem.select.email.filteredList = email.split(",");
          }

          $data.view.elem.select.emailFacturacion.filteredList = [];
          if (emailFacturacion != null && emailFacturacion != undefined && emailFacturacion != "") {
            $data.view.elem.select.emailFacturacion.filteredList = emailFacturacion.split(",");
          }

          $data.vendor = new Vendor({
            clave
            , descripcion
            , canales: canales.split(",")
            , rep: getJson(rep)
            , email: email != null && email != "" ? email.split(",") : null
            , emailFacturacion: emailFacturacion != null && emailFacturacion != "" ? emailFacturacion.split(",") : null
            , status
          });

          this.resetValidators();
          scrollToForm($data);
        }
        , async submit({ $data, $setState }, { clave, descripcion, canales, rep, email, emailFacturacion, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy = true;

            const response = await vendorAPI.update({
              clave
              , descripcion
              , canales: canales.join()
              , rep: setJson(rep)
              , email: email != null && email != "" ? email.join() : null
              , emailFacturacion: emailFacturacion != null && emailFacturacion != "" ? emailFacturacion.join() : null
              , status
            });

            $data.$refs.vendorTable.refreshData();
            $data.view.action.submit.busy = false;
            $setState("initial");
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/operativos/vendor/vendor-state.js